module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-01.57df0e4.webp";